import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method apiRequestOTP
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * @param {object} AuthRequestOTPParam
     */
    apiRequestOTP: function(AuthRequestOTPParam, recapchaKey) {

        var params = AuthRequestOTPParam.getParam();
        params.app_id = Vue.bzbsConfig.client_id;
        params.recaptcha = recapchaKey;

        //var url = this.config().bzbsUrl + "/api/auth/otp";
        // var url = this.config().bzbsUrl + "/modules/chanel/auth/otp";
        var url = this.config().newBzbsModuleUrl + "/auth/otp";
        return BzbsApi.connectBzbsPost(url, null, params);
    },

}
